// Section 8: Rest / unassigned. No output; strength recovers +15 extra. Idle adults over 4
// seasons lose happiness and trust (status contributor). Constants: config.jobs.rest.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { alwaysEligible, noDeltas } from '../../core/content-helpers';
import { defineJob } from '../../core/registry';

export function rest(config: Config) {
  return defineJob({
    id: 'rest',
    label: 'Rest',
    section: 'S8',
    heavy: false,
    output: { kind: 'none' },
    baseYield: 0,
    toolFactor: null,
    toolWear: 0,
    risks: {},
    riskIllness: null,
    requiresBuilding: null,
    minStrength: 0,
    modifierTargets: ['strengthChange'],
    modifiers(ctx, target) {
      if (target.kind !== 'strengthChange') return [];
      const p = ctx.state.people[target.personId];
      return p?.job === 'rest'
        ? [mod.add('job:rest', config.jobs.rest.strengthBonus, 'resting')]
        : [];
    },
    produce: noDeltas,
    eligible: alwaysEligible,
  });
}
